import { SelectionModel } from '@angular/cdk/collections';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ContactState } from 'src/app/_shared/state/contact.state';
import { ContactService } from '../../service/contact.service';
import { AddContactComponent } from '../add-contact/add-contact.component';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements OnInit, OnDestroy {
  contactListOption = [];
  onDestroyNotifier$ = new Subject();
  isDataLoading: boolean = false;
  searchFormCtrl: FormControl = new FormControl();
  contactDataSource = new MatTableDataSource([]);
  selectedContactData = new MatTableDataSource([]);
  selectedRecordIdList = [];
  selection = new SelectionModel<any>(true, []);
  csvRecordListCount = 0;
  SearchForm: FormGroup;
  @Input() csvRecordColumnList;
  @Input() filter;
  @Input() editSelectedInfo = [];
  @Input() campaignMode: any;
  @Output() selectedRecordsEvent = new EventEmitter<any>();
  FilterForm = new FormGroup({});
  @ViewChild('select') select: MatSelect;
  pageSize: any;
  pageIndex: number;
  pageSize1: any;
  pageIndex1: number;
  contactListFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 10, offset: 0 };
  allSelectedContactListFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 10, offset: 0 };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginator1: MatPaginator;
  saveRecordColumnList = ['firstName', 'email', 'action'];
  @ViewChild('fetchCompsDialog', { static: false }) fetchCompsDialog: any;
  dialogRef: any;
  isAllSelectedRecords = false;
  allSelected = true;
  selectedGroupId = [];
  form: FormGroup;
  saveInput: string;
  index: number;
  checkboxChanges$ = new Subject();
  champaignType: string;
  selectedCampaignId: any;
  searchFilterList = [];
  allSelectedContactListIds = [];
  selectedRecordIdListNew = [];
  allSelectedConditions = [];
  totalSelectedIds = [];
  tempSelectedIds = [];
  champaignTypeValue;
  allSelectedRecordListCount: number;
  contactGroup = [];
  error: any;

  constructor(
    private contactState: ContactState,
    private contactService: ContactService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    let params = {};
    this.contactService
      .getContactGroupList(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading, data }) => {
        this.isDataLoading = isLoading;
      });

    this.listenToSearch();
    this.getContactList(this.filter);

    this.checkboxChanges$.pipe(debounceTime(200)).subscribe(() => {
      this.selection.clear();
      this.contactListFetchParams.limit = 10;
      this.contactListFetchParams.offset = 0;
      this.paginator.pageIndex = 0;
      this.paginator1.pageIndex = 0;
      this.isAllSelectedRecords = false;
      this.getContactList();
    });

    this.contactState.contactGroupList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response) => {
      this.contactListOption = response;
      setTimeout(() => {
        this.select.options.forEach((item: MatOption) => item.select());
      }, 2000);
    });

    this.contactState.contactsList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response: any) => {
      if (response) {
        this.contactDataSource = new MatTableDataSource([]);
        this.csvRecordListCount = response?.totalRecords;
        this.contactDataSource.data = response?.paginatedResults;
        this.preserveSelected();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.contactState.selectedContactsList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response: any) => {
      if (response != null) {
        this.selectedRecordIdListNew = response?.selectedRecords;
        this.selectedRecordIdList = response?.selectedRecords;
        if (response?.selectedAll == true) this.selectedCampaignId = response?.selectedRecords[0]?.campaignId;
        this.toShowSelectedRecords();
      }
    });

    if (this.editSelectedInfo) {
      if (this.editSelectedInfo.length != 0) {
        this.selectedRecordIdList = this.editSelectedInfo;
        this.selectedRecordIdListNew = this.editSelectedInfo;
        this.selectedCampaignId = this.editSelectedInfo[0].campaignId;
        this.toShowSelectedRecords(this.isAllSelectedRecords);
      }
    }

    this.contactState.allContactsList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response: any) => {
      if (response) {
        this.selectedContactData.data = response.paginatedResults || response.records;
        this.allSelectedRecordListCount = response?.totalRecords;
        this.selectedRecordIdList = response.paginatedResults || response.records;
        this.totalSelectedIds = response.totalSelectedIds ? response.totalSelectedIds : [];
        this.selectedRecordsEvent.emit(this.totalSelectedIds);
        this.preserveSelected();
      }
    });

    if (
      (changes?.filter?.previousValue &&
        changes.filter.currentValue &&
        changes.filter.currentValue !== changes?.filter?.previousValue &&
        changes.filter.currentValue == 'CAMP_IR_INVT') ||
      changes?.filter?.previousValue == 'CAMP_IR_INVT'
    ) {
      this.getContactList(changes.filter.currentValue);
      this.selectedRecordIdList = [];

      this.contactDataSource.data.forEach((row) => {
        this.selection.deselect(row);
      });
      this.isAllSelectedRecords = false;
      this.selectedContactData.data = [];
      this.paginator.pageIndex = 0;
      this.contactListFetchParams.limit = 10;
      this.contactListFetchParams.offset = 0;
      this.contactState.selectedContactsListValue = null;
    }
  }

  listenToSearch() {
    this.SearchForm = this.formBuilder.group({
      name: [''],
      email: [''],
      zip: [''],
      state: [''],
      city: [''],
    });
    this.searchFilterList = [];

    this.searchFormCtrl.valueChanges.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((searchValue) => {
      return (this.contactDataSource.filter = searchValue?.trim()?.toLowerCase());
    });
  }

  saveSearch() {
    this.contactListFetchParams.limit = 10;
    this.contactListFetchParams.offset = 0;
    this.getContactList();
  }

  toggleSelect(row, checked) {
    this.contactGroup = this.contactGroup.filter((item) => item != row.contactGroupId);
    this.selectedCampaignId = null;
    const selectedIdSet = new Set(this.selectedRecordIdListNew);

    if (this.allSelectedConditions.length > 0 && this.isAllSelectedRecords) {
      let ind = this.allSelectedConditions[this.allSelectedConditions.length - 1].removedContacts.indexOf(row.id);
      if (checked) {
        this.allSelectedConditions[this.allSelectedConditions.length - 1].removedContacts.splice(ind, 1);
      } else {
        this.allSelectedConditions[this.allSelectedConditions.length - 1].removedContacts.push(row.id);
      }
    }
    if (checked) {
      this.tempSelectedIds.push(row);
      if (!this.isAllSelectedRecords) {
        selectedIdSet.add(row);
      }
    } else {
      for (const item of selectedIdSet.values()) {
        if (item.id == row.id) {
          selectedIdSet.delete(item);
        }
      }
    }

    this.selectedRecordIdListNew = [...selectedIdSet];
    if (this.selectedRecordIdList.length >= 1) {
      this.uniqueRecordCount();
    }
    this.toShowSelectedRecords(this.isAllSelectedRecords);
  }

  deleteSelectedRecord(toDelete) {
    this.selectedRecordIdList = this.selectedRecordIdList.filter((obj) => obj.id != toDelete.id);
    this.selectedRecordIdListNew = this.selectedRecordIdListNew.filter((obj) => obj.id != toDelete.id);
    if (this.allSelectedConditions && this.allSelectedConditions.length > 0) {
      this.allSelectedConditions.forEach((element) => {
        if (element.removedContacts) {
          element.removedContacts.push(toDelete.id);
        }
      });
    }

    this.selection.deselect(toDelete);
    this.findIndexInArray(toDelete);
    this.uniqueRecordCount();
    this.toShowSelectedRecords(this.isAllSelectedRecords);
  }

  findIndexInArray(toDelete): void {
    this.index = this.contactDataSource.data.findIndex((obj) => this.compareObjects(obj, toDelete));
    this.selection.deselect(this.contactDataSource.data[this.index]);
  }

  compareObjects(obj1: any, obj2: any): boolean {
    return obj1.id == obj2.id;
  }

  uniqueRecordCount() {
    let records = this.selectedRecordIdList;
    this.selectedContactData.data = records;
  }

  getContactList(champaignTypeValue?) {
    this.tempSelectedIds = [];
    this.champaignTypeValue = champaignTypeValue;
    let params = {
      contactGroupId: this.allSelected ? [] : this.selectedGroupId,
      searchQuery: this.SearchForm.value,
      allContactGroups: this.allSelected,
      limit: this.contactListFetchParams.limit,
      offset: this.contactListFetchParams.offset,
      campaignType: champaignTypeValue,
    };

    this.contactService
      .getContactsList(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isDataLoading = res.isLoading;
      });
  }

  isAllSelected() {
    return this.csvRecordListCount == this.allSelectedRecordListCount;
  }

  masterToggle(event) {
    this.selectedCampaignId = null;
    if (event.checked) {
      this.isAllSelectedRecords = true;
      this.contactDataSource.data.forEach((row) => {
        this.selection.select(row);
      });
      this.allSelectedContactListIds = this.selectedGroupId;

      let SearchValuesEmpty = false;
      if (this.SearchForm?.value) {
        SearchValuesEmpty = Object.values(this.SearchForm.value).every((value) => value === '');
      }

      if (this.allSelectedConditions.length > 0) {
        let obj1 = {
          allSelectedContactListIds:
            this.allSelectedConditions[this.allSelectedConditions.length - 1].allSelectedContactListIds,
          allSelectedSearchQuery:
            this.allSelectedConditions[this.allSelectedConditions.length - 1].allSelectedSearchQuery,
        };
        let obj2 = {
          allSelectedContactListIds: this.allSelectedContactListIds,
          allSelectedSearchQuery: SearchValuesEmpty ? null : this.SearchForm.value,
        };

        if (this.areEqual(obj1, obj2)) {
          this.allSelectedConditions[this.allSelectedConditions.length - 1].removedContacts = [];
        } else {
          this.allSelectedConditions.push({
            allSelectedContactListIds: this.allSelectedContactListIds,
            allSelectedSearchQuery: SearchValuesEmpty ? null : this.SearchForm.value,
            removedContacts: [],
          });
        }
      } else {
        this.allSelectedConditions.push({
          allSelectedContactListIds: this.allSelectedContactListIds,
          allSelectedSearchQuery: SearchValuesEmpty ? null : this.SearchForm.value,
          removedContacts: [],
        });
      }
    } else {
      this.isAllSelectedRecords = false;
      this.contactDataSource.data.forEach((row) => {
        this.selection.deselect(row);
      });
      this.allSelectedContactListIds = this.allSelectedContactListIds.filter(
        (item) => !this.selectedGroupId.includes(item)
      );

      this.allSelectedConditions.pop();
    }
    this.uniqueRecordCount();

    if (this.tempSelectedIds && this.tempSelectedIds.length > 0) {
      this.selectedRecordIdListNew = this.selectedRecordIdListNew.filter(
        (obj1) => !this.tempSelectedIds.some((obj2) => obj1.id === obj2.id)
      );
    }

    this.toShowSelectedRecords(event.checked);
  }

  areEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  toShowSelectedRecords(event?) {
    let selectedContactsIds = this.selectedRecordIdListNew?.map((obj) => obj.id);

    let param = {
      allContactsSelected: event,
      campaignType: this.champaignTypeValue,

      limit: this.allSelectedContactListFetchParams.limit,
      offset: this.allSelectedContactListFetchParams.offset,

      allSelectedConditions: this.allSelectedConditions,
      selectedContacts: selectedContactsIds,
    };
    this.contactService
      .getSelectedContacts(param)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isDataLoading = res.isLoading;
      });
  }

  preserveSelected() {
    this.selection.clear();
    this.contactDataSource.data.forEach((row: any) => {
      if (this.totalSelectedIds && this.totalSelectedIds.includes(row.id)) {
        this.selection.select(row);
      }
    });
  }

  pageChange(event) {
    if (this.contactListFetchParams.offset != event.pageSize * event.pageIndex) {
      this.contactListFetchParams.limit = event.pageSize;
      this.contactListFetchParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.contactListFetchParams.limit = event.pageSize;
      this.paginator.pageIndex = 0;
      this.contactListFetchParams.offset = 0;
    }
    this.getContactList();
  }

  pageChange1(event) {
    if (this.allSelectedContactListFetchParams.offset != event.pageSize * event.pageIndex) {
      this.allSelectedContactListFetchParams.limit = event.pageSize;
      this.allSelectedContactListFetchParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.allSelectedContactListFetchParams.limit = event.pageSize;
      this.paginator1.pageIndex = 0;
      this.allSelectedContactListFetchParams.offset = 0;
    }
    this.toShowSelectedRecords(this.isAllSelectedRecords);
  }

  closeDialog() {
    this.dialogRef.close();
    this.error = '';
  }

  saveList() {
    this.saveInput = '';
    this.error = '';
    this.dialogRef = this.dialog.open(this.fetchCompsDialog);
  }

  createContact() {
    const dialogRef = this.dialog.open(AddContactComponent, {
      width: '385px',
      disableClose: true,
      data: { campaignType: this.campaignMode }, // 👈 pass your key or object here
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        setTimeout(() => {
          this.getContactList(); // Call parent function with result from the dialog
        }, 1000);
      }
    });
  }

  toggleAllSelection() {
    this.selectedGroupId = [];
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
      this.checkboxChanges$.next();
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
      this.checkboxChanges$.next();
    }
  }

  optionClick() {
    this.selectedGroupId = [];
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
      if (item.selected) {
        this.selectedGroupId.push(item.value);
        this.contactGroup.push(item.value); // adding for create campaigns
      }
    });
    this.contactGroup = Array.from(new Set(this.contactGroup));
    this.isAllSelectedRecords = false;
    this.allSelected = newStatus;
    this.checkboxChanges$.next();
  }

  save(val) {
    if (!val) this.error = 'Please Enter the Group Name';
    if (val && this.selectedContactData.data.length == 0) this.error = 'No records has been Selected';
    if (val && this.selectedContactData.data.length > 0) {
      let params = {
        contactList: null,
        contactIdsList: this.totalSelectedIds,
        contactGroupName: val,
      };
      this.contactService
        .addContactList(params)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe(({ isLoading }) => {
          this.dialogRef.close();
        });
    }
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    this.contactState.selectedContactsListValue = null;
    this.contactListOption = [];
    this.contactDataSource.data = [];
    this.selection.clear();
    this.selectedContactData.data = [];
    this.contactState.allContactsListValue = null;
    this.selectedCampaignId = null;
  }
}
